import type { TranslationDict } from './ja'

export const ko: TranslationDict = {
  appTitle: '럭키 애니멀 테리토리',
  help: '플레이 방법',
  helpAria: '플레이 방법',
  settings: '설정',
  settingsAria: '설정',
  close: '닫기',
  closeAria: '닫기',
  player: '플레이어',
  highscore: '최고 점수',
  start: '게임 시작',
  staminaEmpty: '스태미나가 부족합니다',
  ranking: '모두의 영역전',
  difficultyTitle: '난이도 선택',
  difficultyStart: '이 난이도로 시작',
  back: '뒤로',
  today: '오늘',
  weekly: '이번 주',
  alltime: '전체',
  loading: '불러오는 중...',
  noScores: '아직 전적이 없습니다. 첫 영역왕이 되어 보세요!',
  loadFailed: '불러오지 못했습니다',
  you: '나',
  youConstant: '나',
  language: '언어',
  languageNote: '일본어를 포함한 18개 언어를 지원합니다.',
  bgm: 'BGM',
  se: '효과음',
  soundEnableAria: '소리 켜기',
  soundDisableAria: '소리 끄기',
  adWatch: '광고를 끝까지 보기',
  adCancel: '나중에',
  rankSuffix: '위',
  earnedPoints: '{score}pt 획득',
  helpGoalTitle: '🎯 게임 목적',
  helpGoalText: '9x9 보드에 교대로 말을 놓아 자신의 영역(같은 색의 묶음)을 넓힙니다. 최종적으로 점수가 높은 플레이어가 승리합니다.',
  helpWinTitle: '🏆 승리 조건',
  helpWinFive: '가로, 세로, 대각선 중 하나라도 같은 색으로 5개를 먼저 이으면 즉시 승리합니다.',
  helpWinScore: '보드가 가득 차면 점수를 비교하여 승패를 결정합니다(무승부 없음).',
  helpScoreTitle: '💯 점수 계산',
  helpLineBonus: '라인 보너스: 3개, 4개, 5개를 이을 때마다 점수가 가산됩니다.',
  helpClusterBonus: '영역 보너스: 자신의 말이 연결된 묶음의 크기에 따라 점수가 가산됩니다.',
  helpKomi: '덤: 후수 플레이어에게는 점수의 +10%가 핸디캡으로 주어집니다.',
  helpControlsTitle: '🖱️ 조작 방법',
  helpControlsText: '자신의 차례에 보드의 빈 칸을 터치하여 말을 놓을 수 있습니다.',
  helpTipsTitle: '💡 힌트',
  helpTipHell: '실력을 시험해보고 싶다면 가장 어려운 HELL에 도전해 보세요.',
  helpTipCluster: '5개를 잇는 것뿐만 아니라, 영역을 넓히는 것도 점수를 올리는 좋은 방법입니다.',
  resultWinFive: '🎉 5개 잇기 달성! 당신의 승리!',
  resultWinScore: '🎉 점수 승리! 당신의 완승!',
  resultLoseFive: '😿 CPU가 5개를 이었습니다! 당신의 패배.',
  resultLoseScore: '😿 점수 패배... 다음 기회에!',
  resultDraw: '🤝 무승부',
  newHighscore: '🏆 최고 점수 갱신!',
  scoreNone: '점수 없음',
  clusterBonus: '영역 보너스',
  retry: '다시 하기',
  titleBack: '타이틀로',
  scoreHintPlaceStone: '돌을 놓으세요',
  best: '최고',
  clusterUnit: '영역',
  lineCount: '{len}개 연결 x{count}',
  turnCount: '{count}번째 수 · {difficulty}',
  boardPlayerPiece: '당신의 말',
  boardCpuPiece: 'CPU의 말',
  boardPlayerAlt: '나',
  boardCpuAlt: 'CPU',
  boardCellPosition: '{row}행 {col}열',
  boardPlaceable: '놓을 수 있음',
  boardEmpty: '빈 칸',
  boardFlower: '꽃 있음',
  firstPlayerAlt: '선수',
  playerFirst: '당신이 선수입니다!',
  playerSecond: '당신은 후수입니다 (+{bonus}% 덤 포함)',
  cpuFirst: 'CPU가 선수입니다!',
  finalePlayerWin: '당신의 승리!',
  finaleCpuWin: 'CPU 승리!',
  finaleFive: '5개 잇기 달성!',
  finaleTerritory: '영역 승부!',
  winnerAlt: '승자',
  loadingBoot: '기동 중...',
  loadingConnect: '연결 중...',
  loadingProfile: '프로필을 불러오는 중...',
  loadingAssets: '에셋을 불러오는 중...',
  loadingReady: '준비 완료',
  reauthRequiredTitle: '다시 로그인이 필요합니다',
  startupFailedTitle: '기동에 실패했습니다',
  reauthButton: '다시 로그인',
  reloadButton: '새로고침',
  lineReloginButton: 'LINE 다시 로그인',
  reauthReason: '인증 유효 기간이 만료되었습니다. 다시 로그인해 주세요.',
  errorReauth: '인증 유효 기간이 만료되었습니다. 다시 로그인해 주세요.',
  errorForbidden: '이 게임을 이용할 권한이 없습니다.',
  errorNotFound: '게임 데이터를 찾을 수 없습니다.',
  errorRateLimited: '통신이 집중되고 있습니다. 잠시 후 다시 시도해 주세요.',
  errorServer: '서버에 연결할 수 없습니다. 잠시 후 새로고침해 주세요.',
  errorCommunication: '통신 에러가 발생했습니다. 새로고침해 주세요.',
  errorNetwork: '네트워크에 연결할 수 없습니다. 연결 상태를 확인하고 새로고침해 주세요.',
  errorStartup: '기동에 실패했습니다. 새로고침해 주세요.',
  settingsTabGeneral: '설정',
  settingsTabAccount: '계정',
  settingsTabInfo: '정보',
  account: '계정',
  linked: '연동됨',
  guest: '게스트',
  loggedInWith: '{provider} 계정으로 로그인 중',
  loggedIn: '계정으로 로그인 중',
  playingAsGuest: '현재 게스트로 플레이 중입니다.',
  appleLoginBusy: 'Apple 로그인 중...',
  appleLogin: 'Apple로 로그인',
  googleLoginBusy: 'Google 로그인 중...',
  googleLogin: 'Google로 로그인',
  logoutBusy: '로그아웃 중...',
  logout: '로그아웃',
  logoutSuccess: '로그아웃되었습니다',
  logoutFailed: '로그아웃에 실패했습니다',
  appInfo: '앱 정보',
  appName: '앱 이름',
  version: '버전',
  legalInfo: '법적 정보',
  terms: '이용 약관',
  privacy: '개인정보 처리방침',
  operator: '운영자',
  contact: '문의하기',
  copyTap: '탭하여 복사',
  idCopied: 'ID를 복사했습니다',
  copyFailed: '복사에 실패했습니다',
  other: '기타',
  reportAd: '부적절한 광고 신고',
  privacyChoices: 'Ad privacy choices',
  profileEdit: '프로필 편집',
  displayName: '표시 이름',
  displayNamePlaceholder: '이름 입력',
  chooseIcon: '아이콘 선택',
  iconLoadFailed: '아이콘 목록을 가져오지 못했습니다.',
  saveFailed: '저장에 실패했습니다. 다시 시도해 주세요.',
  noIcons: '사용 가능한 아이콘이 없습니다.',
  save: '저장',
  saving: '저장 중...',
  staminaAria: '스태미나 잔량 {stamina} / {max}',
  nextRecovery: '다음 회복까지 {time}',
  adPlaying: '광고 재생 중...',
  recoverFullAd: '광고 시청으로 스태미나 전체 회복',
  dailyBonusAria: '광고를 끝까지 보고 스태미나 +5 받기',
  dailyBonusAd: '광고 시청으로 스태미나 +5',
  legalLastUpdated: '최종 업데이트: {date}',
  privacyTitle: '개인정보 처리방침',
  termsTitle: '이용 약관',
  adPlayingAria: '광고 재생 중',
  adBadge: '▶ 광고',
  adRemaining: '남은 시간 {seconds}초',
  adDevHint: '개발용 테스트 광고입니다. 실제로는 AdMob 동영상이 재생됩니다.',
  adRewardRequirement: '광고를 끝까지 보면 다음 보상을 받을 수 있습니다.',
  adRewardStaminaDetail: '보상: 스태미나를 최대치까지 회복',
  adRewardDailyBonusDetail: '보상: 오늘 1회 보너스로 스태미나 +{amount}',
  adRewardIncompleteNote: '중간에 닫으면 보상을 받을 수 없습니다.',
  adSkipAria: '광고 건너뛰기',
  adSkip: '건너뛰기 ✕',
  adSkipAfter: '{seconds}초 후 건너뛰기 가능',
  offlineMessage: '서버에 연결할 수 없습니다. 일부 기능을 사용할 수 없습니다.',
  reconnecting: '재연결 중...',
  reconnect: '재연결',
  signInTitle: '로그인',
  signInBusy: '로그인 중...',
  signInCancelNote: '로그인을 취소하면 게스트로 계속할 수 있습니다(일부 기능 제한).',
  processing: '처리 중...',
  recoverConfirmTitle: '데이터 덮어쓰기 확인',
  recoverConfirmMessage: '이 계정에는 기존 데이터가 있습니다. 계속하면 현재 기기의 게스트 데이터가 대체됩니다. 계속하시겠습니까?',
  recoverConfirmContinue: '복구하기',
  recoverConfirmCancel: '취소',
  unlinkConfirmTitle: '계정 연동 해제',
  unlinkConfirmMessage: '이 제공업체와의 연동을 해제하면 현재 기기는 게스트 상태로 돌아갑니다. 다른 기기에서 같은 계정으로 로그인하면 기존 데이터는 유지됩니다.',
  unlinkConfirmContinue: '해제하기',
  unlinkConfirmCancel: '취소',
  deleteConfirmTitle: '탈퇴 확인',
  deleteConfirmMessage: '계정을 삭제하면 최고 점수, 로그인 정보, 연동 계정, 초대 내역이 모두 삭제됩니다.\n이 작업은 취소할 수 없습니다. 정말로 탈퇴하시겠습니까?',
  deleteConfirmContinue: '계정 삭제',
  deleteConfirmCancel: '취소',
  adNekoTitle: 'AD 네코',
  matchmakingRemaining: '남은 시간 {seconds}초',
  matchmakingTimeoutMessage: '시간 내에 상대를 찾지 못했습니다. 다시 시도해 주세요.',
  difficultyEasyName: '이지',
  difficultyEasyDescription: '상대가 조금 멍하니 있는 것 같습니다',
  difficultyNormalName: '노멀',
  difficultyNormalDescription: '상대가 가끔 실수를 합니다',
  difficultyHardName: '하드',
  difficultyHardDescription: '상대의 시야가 넓습니다',
  difficultyHellName: '헬',
  difficultyHellDescription: '상대가 매우 강하며 수를 미리 읽습니다',
}
